import { computed, Injectable, signal } from '@angular/core';
import { Role } from '../../shared/enums/role.enum';
import { User } from '../../shared/models/user/user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthStateService {
  public readonly user = signal<User | null>(null);
  public readonly initialized = signal(false);
  public readonly isLoggedIn = computed<boolean>(() => !!this.user());
  public readonly isAdmin = computed<boolean>(
    () => this.user()?.details?.role === Role.ADMIN,
  );

  public clear(): void {
    this.user.set(null);
  }
}
